// The notification pages are sections of «حساب کاربری». /notifications and /notifications/settings
// (the former «مرکز اعلان» menu, still in links the backend sends and in bookmarks) lead here.
export const NOTIFICATIONS_PATH = '/profile/notifications'
export const NOTIFICATION_SETTINGS_PATH = '/profile/notifications/settings'
